export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70620227d52cb982f0cb5d60d71fddcbc540a4c533&name=pushAdClickData!'